import { useContract } from "utils/contract"
import ALLOCATION_ABI from "abis/allocation.json"
import { Contract } from "ethers"

export function useAllocationContract(contractAddress: string): Contract | null {
  return useContract(contractAddress, ALLOCATION_ABI)
}
